import React, { type ReactElement } from 'react';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

type Props = {
  className?: string;
  onClick: () => void;
  disabled: boolean;
};

export default function ClearFiltersButton({ className, onClick, disabled }: Props): ReactElement {
  return (
    <button
      type="button"
      className={clsx('btn-clear btn btn-outline-danger', className)}
      onClick={onClick}
      disabled={disabled}
    >
      Clear Filters
      <FontAwesomeIcon className="ms-2" icon={faCircleXmark} fixedWidth />
    </button>
  );
}
